// utils

// const
import { TYPE } from 'app/config/prescription_content';
// import { PAD_ITEM_STATE } from 'app/config/pad_item.js';
import _ from 'lodash';
// components-js
import Amount from './Amount';
import PadItem from './PadItem';
// config
import { PAD_ITEM_TYPE } from 'app/config/pad_item.js';

/**
 * represents an instance of PadItemMatMed
 * @class PadItemMatMed
 * @extends PadItem
 */
export default class PadItemMatMed extends PadItem {
  constructor(state) {
    super(state);

    this._padItemMatMeds = [];
  }

  update(padPrescriptions, padDetails) {
    padPrescriptions = _.cloneDeep(padPrescriptions);
    const padItemMatMeds = this._updatePadItemMatMeds(padPrescriptions, padDetails);

    super.replace(padItemMatMeds);
    return this;
  }

  _updatePadItemMatMeds(padPrescriptions, padDetails) {
    // eslint-disable-next-line no-unused-vars
    for (const padPrescription of padPrescriptions) {
      delete padPrescription.type;
      this._processMedicamentAndDiet(padPrescription, padDetails);
      this._processProcedure(padPrescription, padDetails);
    }

    return this._padItemMatMeds;
  }

  _processMedicamentAndDiet(padPrescription, padDetails) {
    const { type, prescriptionTypeForm, medicamentForm, dietForm } = padPrescription;

    const isMedicament = !!medicamentForm;
    const isDiet = !!dietForm;

    if (!isMedicament && !isDiet) return;
    if (type === TYPE.SUSPENDED) return;

    const itemId = prescriptionTypeForm.medicamentId
      ? prescriptionTypeForm.medicamentId
      : prescriptionTypeForm.dietId;

    const padPrescriptionForm = isMedicament ? { ...medicamentForm } : { ...dietForm };

    this._updatePadItemMatMedsByType(
      {
        itemId,
        prescriptionTypeForm,
        padPrescriptionForm,
        padPrescription,
        type
      },
      padDetails
    );
  }

  _processProcedure(padPrescription, padDetails) {
    const { type, prescriptionTypeForm, procedureForm, procedureKitForm } = padPrescription;

    const isProcedure = !!procedureForm && !!procedureKitForm;

    if (!isProcedure) return;
    if (type === TYPE.SUSPENDED) return;

    // const { padPrescriptionMatMeds } = procedureKitForm;

    // eslint-disable-next-line no-unused-vars
    for (const padPrescriptionMatMed of procedureKitForm.kitProcedures) {
      const { matMedId, quantity, name } = padPrescriptionMatMed;
      const itemId = matMedId;
      const padPrescriptionForm = { ...procedureForm, name, itemId, dose: quantity };

      this._updatePadItemMatMedsByType(
        {
          itemId,
          prescriptionTypeForm,
          padPrescriptionForm,
          padPrescription,
          type
        },
        padDetails
      );
    }
  }

  _updatePadItemMatMedsByType(padPrescriptionForms, padDetails) {
    let { itemId, prescriptionTypeForm, padPrescriptionForm, type /* , padPrescription */ } =
      padPrescriptionForms;

    const existingPadItemMatMed = this._padItemMatMeds.find(
      padItemMatMed => padItemMatMed.itemId === itemId
    );

    if (!existingPadItemMatMed) {
      const padItemMatMed = this._buildPadItemMatMed(
        itemId,
        prescriptionTypeForm,
        padPrescriptionForm,
        padDetails,
        type
      );
      this._padItemMatMeds.push(padItemMatMed);
    } else {
      const amount = this._calculateAmount(padPrescriptionForm, padDetails);
      this._padItemMatMeds = [...this._padItemMatMeds].map(padItemMatMed => {
        if (padItemMatMed.itemId === itemId) {
          return {
            ...padItemMatMed,
            amount: padItemMatMed.amount + amount
          };
        }
        return { ...padItemMatMed };
      });
    }
  }

  _calculateAmount(padPrescriptionForm, padDetails) {
    const { calendarType } = padPrescriptionForm;
    const amountEntity = new Amount(calendarType);

    return amountEntity.calculate({ ...padPrescriptionForm }, padDetails);
  }

  _buildPadItemMatMed(itemId, prescriptionTypeForm, padPrescriptionForm, padDetails, type) {
    const { medicamentId, dietId, procedureId } = prescriptionTypeForm;
    // const itemId = medicamentId || dietId || padPrescriptionForm.itemId;
    let name = '';
    if (medicamentId) name = _.get(prescriptionTypeForm, 'formAddOn.medicamentName');
    if (dietId) name = _.get(prescriptionTypeForm, 'formAddOn.dietName');
    if (procedureId) name = _.get(prescriptionTypeForm, 'formAddOn.procedureName');

    const amount = this._calculateAmount(padPrescriptionForm, padDetails);

    return {
      itemId,
      amount,
      name,
      padType: type,
      type: PAD_ITEM_TYPE.MAT_MED
    };
  }
}
